import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

import classNames from "./../../../utils/classNames";
import { IShippingQuote } from "../../../models/Shipping";
import PriceFormat from "../../../utils/priceFormat";

interface ShippingQuoteTableProps {
  shippingQuotes: IShippingQuote[];
  onServiceSelect: (service: string) => void;
  selectedService?: string;
}

export function ShippingQuoteTable({
  shippingQuotes,
  onServiceSelect,
  selectedService,
}: ShippingQuoteTableProps) {
  const { t } = useTranslation("stock");

  return (
    <table className="divide-y border divide-gray-300">
      <thead>
        <tr className="bg-primary-50 text-gray-800">
          <th className="py-1.5 px-2 text-sm font-semibold lg:table-cell text-left"></th>
          <th className="py-1.5 px-2 text-sm font-semibold lg:table-cell text-left">
            {t("Service")}
          </th>
          <th className="py-1.5 px-2 text-sm font-semibold lg:table-cell text-left">
            {t("Price")}
          </th>
        </tr>
      </thead>
      <tbody>
        {shippingQuotes?.map((sq) => {
          let selected = sq.service === selectedService;
          const isValid = sq.isValid ?? true;

          return (
            <tr
              onClick={() => {
                if (!isValid) return;
                onServiceSelect(sq.service);
              }}
              className={classNames(
                isValid ? "cursor-pointer hover:bg-gray-50" : "cursor-not-allowed bg-gray-100 text-gray-400",
                selected ? "bg-gray-100" : ""
              )}
            >
              <td width="5%" className="px-3 py-1.5 border text-sm">
                <CheckCircleIcon
                  height={24}
                  className={selected && isValid ? "text-green-500" : "text-gray-400"}
                />
              </td>
              <td width="85%" className="px-3 py-1.5 border text-sm">
                {sq.name}
                {!isValid && sq.invalidReason && (
                  <p className="text-xs text-gray-400">{sq.invalidReason}</p>
                )}
              </td>
              <td className="px-3 py-1.5 border text-sm">{PriceFormat(sq.price)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
